module.exports = __webpack_public_path__ + "img/_5.55fd34f0.png";